import React from 'react';
import PropTypes from 'prop-types';

function SectionStepInfo(props) {
  const { section, description } = props;
  return (
    <div className="ds-progress-indicator">
      {section}
      <p className="ds-h4">{description}</p>
    </div>
  );
}

SectionStepInfo.propTypes = {
  section: PropTypes.string.isRequired,
  description: PropTypes.string,
};

SectionStepInfo.defaultProps = {
  description: null,
};

export default SectionStepInfo;
